import { render } from "./completeOrder.vue?vue&type=template&id=4c8832e8&scoped=true"
import script from "./completeOrder.vue?vue&type=script&lang=js"
export * from "./completeOrder.vue?vue&type=script&lang=js"

import "./completeOrder.vue?vue&type=style&index=0&id=4c8832e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8832e8"]])

export default __exports__